export enum TagCategoriesEnum {
  CUSTOM = 'custom',
  CHANNEL = 'channel',
  LOCATION = 'location',
  CUST_SEGMENT = 'custSegment',
  LOYALTY = 'loyalty',
  TV = 'tv',
  INTERNET = 'internet',
  DISCOUNT = 'discount',
  HARDWARE = 'hardware'
}



// WEBPACK FOOTER //
// ./src/app/helpers/tag-categories.enum.ts